import { http } from '@shared/api';
import type { CreateLeadRequest, Lead, LeadStatus } from '../model/types';

export const crmApi = {
  list: (status?: LeadStatus) =>
    http.get('crm/leads', {
      searchParams: status ? { status } : undefined,
    }).json<Lead[]>(),

  create: (body: CreateLeadRequest) => http.post('crm/leads', { json: body }).json<Lead>(),

  patchStatus: (id: string, status: LeadStatus) =>
    http.patch(`crm/leads/${id}/status`, { json: { status } }).json<Lead>(),

  patchNotes: (id: string, notes: string | null) =>
    http.patch(`crm/leads/${id}/notes`, { json: { notes } }).json<Lead>(),

  patchTitle: (id: string, title: string) =>
    http.patch(`crm/leads/${id}/title`, { json: { title } }).json<Lead>(),
};
